

import {
    Component,
    OnInit,
  } from "@angular/core";
  import { NGXLogger } from "ngx-logger";
  import { ConfirmationService, MessageService } from "primeng/api";


  import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";


  import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { Subject } from "rxjs";
  import { HttpClient } from "@angular/common/http";
import { StoricoPratica } from "src/app/models/pratica.storico.model";
import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";
import { ExcelService } from "src/app/services/excelService.service";
import { StoricoProntofibra } from "src/app/models/prontofibra.storico.model";
import { Prontofibra_Firestore } from "src/app/models/prontofibra.firestore.model";


@Component({
    selector: "app-storico-pf",
    templateUrl: './storico-pf.component.html',
    styleUrls: ["../prontofibra.component.css"],
  })
  export class StoricoPFComponent implements OnInit {


    protected _onDestroy = new Subject<void>();

    protected storico:StoricoProntofibra[]=[];
    protected prontofibra: Prontofibra_Firestore;

    protected ref: DynamicDialogRef;
    isLoadingResults = false;

    constructor(
        private logger: NGXLogger,
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public confirmationService:ConfirmationService,
        public dialogService: DialogService,
        private stiliService:StiliService ,
        private utilService:UtilService,
        private excelService:ExcelService
      ) {

      this.storico = this.config.data.storicoProntofibra;
      this.logger.info(this.storico);
      this.prontofibra = this.config.data.prontofibra;
    }

   
    ngOnInit(): void {

    }
   
    formattaStorico(storico:StoricoProntofibra):string{
      return storico.stato.label.toString();
    }

    scaricaReportStorico(){
      this.excelService.exportStoricoPFToExcel(this.storico, 'storico_pf_'+this.prontofibra.cui+'.xlsx');
    }
    
  }
